const CONTACT_API = {
  // 账号登录
  loginAccount: {
    method: 'get',
    url: 'auth/login/account'
  },
  // SP教材库列表
  officialspbooklist: {
    method: 'get',
    url: 'official/sp/book/list'
  },
  // SP人才库
  onlineconsultationsplist: {
    method: 'post',
    url: 'online/consultation/sp/list'
  },
  // SP案例库
  caseexamlist: {
    method: 'get',
    url: 'case/exam/list'
  },
  // SP教具库
  officialsptoollist: {
    method: 'get',
    url: 'official/sp/tool/list'
  },
  // SP预约
  officialsparrangesave: {
    method: 'post',
    url: 'official/sp/arrange/save'
  },
  // 专家团队/SP师资库
  officialteacherslist: {
    method: 'get',
    url: 'official/teachers/list'
  },
  // 列表(无token)
  officialnewslist: {
    method: 'get',
    url: 'official/news/list'
  },
  // 查看(无token)
  officialnewsdetail: {
    method: 'get',
    url: 'official/news/detail'
  },
  // 课程列表(无token)
  officialcourselist: {
    method: 'get',
    url: 'official/course/list'
  },
  // 活动通知列表
  officialnoticelist: {
    method: 'get',
    url: 'official/notice/list'
  },
  // 活动通知查看
  officialnoticedetail: {
    method: 'get',
    url: 'official/notice/detail'
  },
  // 其他证书类型
  officialcertificatetype: {
    method: 'get',
    url: 'official/certificate/type'
  },
  // 其他证书
  officialcertificatequery: {
    method: 'get',
    url: 'official/certificate/query'
  },
  // 其他证书
  officialnewsall: {
    method: 'get',
    url: 'official/news/all'
  }
}
export default CONTACT_API
